/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventCreateRequest as ModelsWebhookWebhookEventCreateRequest } from '../../models/Models/Webhook/webhook-event-create-request';
import { WebhookEventCreateRequestBaseResponse as ModelsWebhookWebhookEventCreateRequestBaseResponse } from '../../models/Models/Webhook/webhook-event-create-request-base-response';

export interface V3WebhooksRegisterPost$Xml$Xml$Params {
      body?: ModelsWebhookWebhookEventCreateRequest
}

export function v3WebhooksRegisterPost$Xml$Xml(http: HttpClient, rootUrl: string, params?: V3WebhooksRegisterPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3WebhooksRegisterPost$Xml$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>;
    })
  );
}

v3WebhooksRegisterPost$Xml$Xml.PATH = '/v3/webhooks/register';
